<template>
  <div>
    <v-item-group active-class="selected-item"
                  multiple
                  :max="selectMaxNumber"
                  v-model="selectServices">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h3>請選擇最少<span class="blue--text">&nbsp;{{ selectMinNumber }}&nbsp;</span>個，最多<span class="blue--text">&nbsp;{{ selectMaxNumber }}&nbsp;</span>個您感興趣的個平台功能</h3>
            <div>並且為它們排序！</div>
          </v-col>
          <v-col v-for="option in options"
            :key="option.id"
            cols="12"
            md="3"
            class="py-1"
          >
            <v-item v-slot:default="{ active, toggle }">
              <v-card>
                <v-card-title class="cursor-pointer pa-2">
                  <v-flex>
                    <div @click="toggle"
                         :class="active ? 'selected-icon' : 'unselected-icon'">
                      {{ selectPosition(option.id) }}
                    </div>
                  </v-flex>
                  <v-flex>
                      <span @click="toggle"
                            class="ml-2 option-title">{{ option.title }}</span>
                  </v-flex>
                  <v-flex>
                    <v-spacer></v-spacer>
                    <v-btn icon
                           small
                           @click="changeOptionDescription(option.id)">
                      <v-icon>{{ toggleOptions[option.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-flex>
                </v-card-title>
                <v-expand-transition>
                  <div v-show="toggleOptions[option.id]">
                    <v-divider></v-divider>
                    <v-card-text @click="toggle">
                      {{ option.description }}
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-item>
          </v-col>
          <v-col cols="12">
            <v-input v-show="selectErrorHint"
                     :error-messages="['請至少選擇 5 個']"
                     error
                     readonly
                     class="error--text"></v-input>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
    <v-btn text
           @click="previousStep">上一步</v-btn>
    <v-btn
      color="primary"
      @click="nextStep"
    >
      下一步
    </v-btn>
  </div>
</template>

<script>
import { db } from '../plugins/db'
const fStore = db.firestore()

export default {
  name: 'Step2',
  props: {
    userId: String
  },
  data () {
    return {
      valid: true,
      options: null,
      step: 2,
      selectServices: [],
      selectMinNumber: 5,
      selectMaxNumber: 8,
      enabled: true,
      dragging: false,
      toggleOptions: {},
      selectErrorHint: false
    }
  },
  created () {
    fStore.collection('1799-services-version-01').doc('options').get().then((response) => {
      const data = response.data()
      const optionsCopy = {}
      this.options = data
      Object.values(data).forEach((item) => {
        optionsCopy[item.id] = false
      })
      this.toggleOptions = {
        ...optionsCopy
      }
    })
  },

  watch: {
    selectServices () {
      this.selectErrorHint = this.selectServices.length < 5
    }
  },

  methods: {
    nextStep () {
      if (this.selectServices.length > 4) {
        debugger
        this.$emit('toggleOfflineClasses', this.selectServices.includes(4))
        this.$emit('toggleOnlineClasses', this.selectServices.includes(5))

        const services = this.selectServices.map((item) => {
          return this.options[item]
        })

        fStore.collection('form-1').doc(this.userId).update({
          selectServices: Object.assign({}, services)
        }).then(() => {
          if (this.selectServices.includes(4) || this.selectServices.includes(5)) {
            this.$emit('goToStep', this.step + 1)
          } else {
            this.$emit('goToStep', this.step + 2)
          }
        })
      }
    },
    previousStep () {
      this.$emit('goToStep', this.step - 1)
    },
    changeOptionDescription (id) {
      this.toggleOptions[id] = !this.toggleOptions[id]
    },

    selectPosition (id) {
      return this.selectServices.length > 0 ? this.selectServices.indexOf(id - 1) + 1 : '0'
    }
  }
}
</script>

<style lang="scss"
       scoped>
  .cursor-pointer {
    cursor: pointer;
  }

  .option-title {
    font-size: 1rem;
  }

  .unselected-icon {
    width: 26px;
    height: 26px;
    color: transparent;
    border-radius: 50%;
    background-color: transparent;
    border: 1px solid #1976d2;
    line-height: 1.25rem;
    padding: 2px;
  }

  .selected-icon {
    width: 26px;
    height: 26px;
    color: white;
    border-radius: 50%;
    background-color: #1976d2;
    border: 1px solid #1976d2;
    line-height: 1.25rem;
    padding: 2px;
  }
  .selected-item {
    opacity: 0.5;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .sortable-chosen {
    cursor: grabbing;
  }

  .card-item {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
</style>
